const waves = '/assets/icons/waves.svg';
const labSelect = '/assets/icons/select-lab.svg';
const labReview = '/assets/icons/labReview.png';
const bloodDraw = '/assets/icons/lab-test2.png';
const goals = '/assets/icons/goals.svg';
const mission = '/assets/icons/mission.svg';
const vision = '/assets/icons/vision.svg';
const briefCase = '/assets/icons/case.svg';
const rightArrow = '/assets/icons/right-arrow.svg';
const watch = '/assets/icons/24Hr.png';
const card1 = '/assets/icons/card1.png';
const card2 = '/assets/icons/card2.png';
const card3 = '/assets/icons/card3.png';
const card4 = '/assets/icons/card4.png';
const circle = '/assets/icons/circle.png';
const common = '/assets/icons/commonMedical.svg';
const std = '/assets/icons/sexualHealth.svg';
const mental = '/assets/icons/mentalHealth.svg';
const mens = '/assets/icons/mensHealth.svg';
const womens = '/assets/icons/womensHealth.svg';
const polygon1 = '/assets/icons/polygon.svg';
const polygon2 = '/assets/icons/polygon2.svg';
const swirls = '/assets/icons/swirls.svg';
const hair = '/assets/icons/hair.svg';
const logoSite = '/assets/icons/logoSite.svg';
const tick = '/assets/icons/tick.svg';
const tickBlack = '/assets/icons/tickBlack.svg';
const cross = '/assets/icons/cross.svg';
const logoWhite = '/assets/icons/logoWhite.png';
const logoWhiteFull = '/assets/icons/logoWhiteFull.png';
const clip = '/assets/icons/asset1.svg';
const greenCircle = '/assets/icons/mobileCircle.png';
const phone = '/assets/icons/onlyPhone.png';
const stars = '/assets/icons/stars.svg';
const bannerCard = '/assets/icons/bannerCard.svg';
const circlesR = '/assets/icons/circles.svg';
const menSign = '/assets/icons/men.png';
const womanSign = '/assets/icons/woman.svg';
const womanSignInvert = '/assets/icons/womenGW.svg';
const bulletpoint = '/assets/icons/bullet.svg';
const bulletpointInvert = '/assets/icons/bulletInvert.svg';
const treatments = '/assets/icons/treatments.png';
const phoneView = '/assets/icons/combinational.png';
const chlamydiaTreatment = '/assets/icons/treatmentPlan1.png';
const treatmentPlan2 = '/assets/icons/Group 3164.png';

const dentalTreatment = '/assets/icons/dentalTreatment.png';
const gonorrheaTreatment = '/assets/icons/goneTreatment.png';
const lab = '/assets/images/lab.webp';
const homepage1 = '/assets/images/homepage/home1.jpg';
const homepage2 = '/assets/images/homepage/home2.jpg';
const homeProp1 = '/assets/images/homepage/prop1.png';
const homeProp2 = '/assets/images/homepage/prop2.png';
const location = '/assets/images/location.png';
const doc = '/assets/images/doc.webp';
const doc2 = '/assets/images/doc2.jpg';
const doc3 = '/assets/images/doc5.jpg';
const std1 = '/assets/images/std1.webp';
const std2 = '/assets/images/std2.webp';
const std3 = '/assets/images/std3.webp';
const pinkEyes = '/assets/images/pink-eye.jpg';
const stddr1 = '/assets/std/std1.png';

const stdCircleBlue = '/assets/std/circle-blue.svg';
const stdCircleGreen = '/assets/std/circle-green.svg';
const how1 = '/assets/std/1.svg';
const how2 = '/assets/std/2.svg';
const how3 = '/assets/std/3.svg';
const stdDoctor1 = '/assets/std/std2.png';

const stdDoctor3 = '/assets/std/std3.png';
const stdDoctor4 = '/assets/std/std4.png';
const headerBG = '/assets/images/headerBG.png';
const refillBottle = '/assets/images/refill/refill_bottle.png';
const refill2 = '/assets/images/refill/refill2.png';
const refill3 = '/assets/images/refill/refill3.png';
const refill4 = '/assets/images/refill/refill4.png';
const iconRefill1 = '/assets/images/refill/icon1.svg';
const iconRefill2 = '/assets/images/refill/icon2.svg';
const tickWhite = '/assets/images/refill/tick_white.svg';
const tickGreen = '/assets/images/refill/tick_green.svg';
const how1Refill = '/assets/images/refill/how1.svg';
const how2Refill = '/assets/images/refill/how2.svg';
const how3Refill = '/assets/images/refill/how3.svg';
const dp1 = '/assets/images/DPs/dp1.png';
const dp2 = '/assets/images/DPs/dp2.png';
const dp3 = '/assets/images/DPs/dp3.png';
const dp4 = '/assets/images/DPs/dp4.png';
const dp5 = '/assets/images/DPs/dp5.png';
const dp6 = '/assets/images/DPs/dp6.png';
const circles = '/assets/images/DPs/circles.jpg';
const login = '/assets/images/login-doc.webp';
const vaginosis1 = '/assets/images/vaginosis1.jpg';
const vaginosis2 = '/assets/images/vaginosis2.png';
const vaginosis3 = '/assets/images/vaginosis3.jpg';
const chlamydia1 = '/assets/images/chlamydia1.jpg';
const chlamydia2 = '/assets/images/chlamydia2.jpg';
const chlamydia3 = '/assets/images/prevention1.png';
const pinkeye2 = '/assets/images/pinkeye-prevention.jpg';
const hairloss = '/assets/images/hair-loss.jpg';
const hairloss2 = '/assets/images/hairloss-causes.jpg';
const doctor = '/assets/images/treatment-doctor.jpg';
const Urethritis = '/assets/images/Urethritis.jpg';
const Urethritis2 = '/assets/images/urethritis2.jpg';
const Mycoplasma = '/assets/images/mycoplasma.jpg';
const Mycoplasma2 = '/assets/images/mycoplasma-transmission.jpg';
const Stye = '/assets/images/stye.jpg';
const Ureaplasma = '/assets/images/ureaplasma.jpg';
const Ureaplasma2 = '/assets/images/ureaplasma-transmission.jpg';
const dental1 = '/assets/images/dental-pain.jpg';
const dental2 = '/assets/images/infection-transmission.jpg';
const dental3 = '/assets/images/oral-care.jpg';
const gonorrhea1 = '/assets/images/gone1.jpg';
const gonorrhea2 = '/assets/images/gone2.jpg';
const gonorrhea3 = '/assets/images/gone3.png';
const pharmacy = '/assets/images/pharmacy.jpg';
const uti1 = '/assets/images/uti1.jpg';
const uti3 = '/assets/images/uti3.png';
const Athlete = '/assets/images/athletes-foot.jpg';
const LogoTransparent = '/assets/icons/LogoTransparent.png';
const board1 = '/assets/icons/board1.png';
const vendor = '/assets/icons/vendor.png';
const thankyou = '/assets/images/thankyou.jpg';
const blogBanner = '/assets/images/blogBanner.png';
const oralThrush = '/assets/images/oral-thrush.jpg';
const bacteria1 = '/assets/images/bacteria-growth.jpg';
const docTreatment = '/assets/images/Group 3075D.png';
const migraine = '/assets/images/mirgaine.jpg';
const migraineCauses = '/assets/images/mirgaine-causes.jpg';
const diseaseTreatment2 = '/assets/images/disease-treatment-2.jpg';
const jockItch = '/assets/images/jock-itch.jpg';
const insomnia = '/assets/images/woman-suffering-from-insomnia.jpg';
const insomniaCauses = '/assets/images/insomnia-causes.jpg';
const socialAnxiety = '/assets/images/social-anxiety.jpg';
const socialAnxietyCauses = '/assets/images/social-anxiety-causes.jpg';
const anxiety = '/assets/images/anxiety.jpg';
const anxietyCauses = '/assets/images/anxiety-causes.jpg';
const motionSickness = '/assets/images/motion-sickness.jpg';
const tabs = '/assets/images/Group 3196.jpg';
const depression = '/assets/images/depression.jpg';
const bronchitis2 = '/assets/images/examining-bronchitis.jpg';
const bronchitis = '/assets/images/man-coughing.jpg';
const birthControl = '/assets/images/birth-control.jpg';
const bcIcon1 = '/assets/icons/condom-package_hires.png';
const bcIcon2 = '/assets/icons/pills.png';
const bcIcon3 = '/assets/icons/sperm-bank_hires.png';
const bcIcon4 = '/assets/icons/syringe.png';
const eyelashGrowth = '/assets/images/eyelash-growth.jpg';
const eyelashGrowth2 = '/assets/images/eyelashes-growth-steps.jpg';
const acne = '/assets/images/acne.jpg';
const acneCauses = '/assets/images/acne-causes.jpg';
const smoking1 = '/assets/images/smoking-bad.jpg';
const smoking2 = '/assets/images/quit-smoking.jpg';
const periodDelay = '/assets/images/period-delay.jpg';
const genitalWarts = '/assets/images/genital-warts.jpg';
const treatmentPlanSTD = '/assets/images/Man Doctor Consultation.svg';
const boil1 = '/assets/images/boil.jpg';
const scabies = '/assets/images/scabies.jpg';

const psoriasis = '/assets/images/psoriasis.JPG';
const psoriasisCauses = '/assets/images/stressed-out.jpg';
// const uti3 = '/assets/images/uti3.png';
const lice = '/assets/images/lice.jpg';
const liceTransmission = '/assets/images/lice-transmission.jpg';
const poisonIvy = '/assets/images/poison-ivy.jpg';
const mentalHealthGraphic = '/assets/images/Mental Health 3.svg';
const adhd1 = '/assets/images/adhd.jpg';
const adhd2 = '/assets/images/adhd-causes.jpg';
const acid1 = '/assets/images/acid-reflux.jpg';
const acid2 = '/assets/images/acid-reflux-causes.jpg';
const weightLoss = '/assets/images/weight-loss.jpg';
const weightLossTreatment = '/assets/images/diet_3.jpg';
const mentalHeroElement = '/assets/images/mentalHeroElement.svg';
const mentalHero = '/assets/images/mentalHero.png';
const mentalType1 = '/assets/images/docTypes.png';
const mental3 = '/assets/images/mental3.png';
const mental4 = '/assets/images/mental4.png';
const mental5 = '/assets/images/mental5.png';
const diabetes1 = '/assets/images/diabetes1.jpg';
const diabetes2 = '/assets/images/diabetes2.jpg';
const diabetes3 = '/assets/images/diabetes3.svg';
const allergy1 = '/assets/images/allergy1.jpg';
const allergy2 = '/assets/images/allergy2.jpg';
const UMC1 = '/assets/images/urgent-medical-care/umc1.png';
const UMChexa = '/assets/images/urgent-medical-care/hexagone.png';
const UMChexaEmpty = '/assets/images/urgent-medical-care/hexaempty.png';
const UMCjalebi = '/assets/images/urgent-medical-care/jaelbi.png';
const UMCstat1 = '/assets/images/urgent-medical-care/stat1.png';
const UMCstat2 = '/assets/images/urgent-medical-care/stat2.png';
const UMCstat3 = '/assets/images/urgent-medical-care/stat3.png';
const UMChiw1 = '/assets/images/urgent-medical-care/hiw1.png';
const UMChiw2 = '/assets/images/urgent-medical-care/hiw2.png';
const UMChiw3 = '/assets/images/urgent-medical-care/hiw3.png';
const UMCdr1 = '/assets/images/urgent-medical-care/drCircle.png';
const UMCdr2 = '/assets/images/urgent-medical-care/comparison.png';

const UMCpricing = '/assets/images/urgent-medical-care/pricing.png';
const careerBanner = '/assets/images/careers.jpg';
const UMCheader1 = '/assets/images/urgent-medical-care/header1.svg';
const UMCheader2 = '/assets/images/urgent-medical-care/header2.svg';
const UMCheader3 = '/assets/images/urgent-medical-care/header3.svg';
const UMCheader4 = '/assets/images/urgent-medical-care/header4.svg';
const UMCheader5 = '/assets/images/urgent-medical-care/header5.svg';
const UMCbanner = '/assets/images/urgent-medical-care/condition-banner-bg.png';

const sickNote1 = '/assets/images/sick-note.jpg';
const notehow1 = '/assets/icons/note/note1.png';
const notehow2 = '/assets/icons/note/note4.png';
const notehow3 = '/assets/icons/note/note3.png';
const notepipeGreen = '/assets/icons/note/pipe-green.png';
const notepipeBlue = '/assets/icons/note/pipe-blue.png';
const notepipeBlueTwo = '/assets/icons/note/pipe-blue-2.png';

const doxy1 = '/assets/images/doxypep/doxy1.png';
const doxy2 = '/assets/images/doxypep/doxy2.png';

const homeModalImage1 = '/assets/images/homepage/modalImg1.png';
const homeModalImage2 = '/assets/images/homepage/modalImg3.png';
const homeModalImage3 = '/assets/images/homepage/modalImg4.png';

const weightloss1 = '/assets/images/services/weightLoss.png';
const weightloss2 = '/assets/images/services/weight-loss-2.jpg';
const faqImage = '/assets/images/components/faqs.png';
const faqs = '/assets/images/faqs/faq.png';
//about
const about1 = '/assets/images/about/about1.png';
const about2 = '/assets/images/about/about2.png';
const about3 = '/assets/images/about/about3.png';
const about4 = '/assets/images/about/about4.png';
const about5 = '/assets/images/about/about5.png';
//howItworks
const howItworks1 = '/assets/icons/components/how1.png';
const howItworks2 = '/assets/icons/components/how2.png';
const howItworks3 = '/assets/icons/components/how3.png';
//Avatar
const avatar = '/assets/images/avatar.png';
const avatarFemale = '/assets/images/avatarFemale.png';
//Arrow
const arrowServices = '/assets/icons/arrowCondition.png';
//Weight Loss
const heroWeight = '/assets/images/services/weight-loss/hero.jpg';
const plusWomen = '/assets/images/services/weight-loss/plusWomen.png';
const heroWeightWeight = '/assets/images/services/weight-loss/heroWeight.jpg';
const firstWeight = '/assets/images/services/weight-loss/first.jpeg';
const secondWeight = '/assets/images/services/weight-loss/second.jpeg';
const thirdWeight = '/assets/images/services/weight-loss/third.jpeg';
const redWeight = '/assets/images/services/weight-loss/red.jpeg';
const yellowWeight = '/assets/images/services/weight-loss/yellow.jpeg';
const bannerWeight1 = '/assets/images/services/weight-loss/banner1.png';
const bannerWeight2 = '/assets/images/services/weight-loss/banner2.png';
const bannerWeight3 = '/assets/images/services/weight-loss/banner3.png';
const howToWeight1 = '/assets/images/services/weight-loss/howTo1.png';
const howToWeight2 = '/assets/images/services/weight-loss/howTo2.png';
const howToWeight3 = '/assets/images/services/weight-loss/howTo3.png';
const weightProgram1 = '/assets/images/services/weight-loss/first.jpeg';
const weightProgram2 = '/assets/images/services/weight-loss/second.jpeg';
const weightProgram3 = '/assets/images/services/weight-loss/third.jpeg';
const doxyWeight1 = '/assets/images/services/weight-loss/subpages/doxy1.png';
const semaglutideIcon1 =
  '/assets/images/services/weight-loss/subpages/icon1.png';
const semaglutideIcon2 =
  '/assets/images/services/weight-loss/subpages/icon2.png';
const semaglutideIcon3 =
  '/assets/images/services/weight-loss/subpages/icon3.png';

const semaglutide =
  '/assets/images/services/weight-loss/subpages/semaglutide1.png';
const semaglutide2 =
  '/assets/images/services/weight-loss/subpages/semaglutide2.png';
const semaglutide3 =
  '/assets/images/services/weight-loss/subpages/semaglutide3.png';
const semaglutide4 =
  '/assets/images/services/weight-loss/subpages/semaglutide4.jpg';
const semaglutideMobile =
  '/assets/images/services/weight-loss/subpages/semaglutideMobile.png';
const doxyWeight2 = '/assets/images/services/weight-loss/subpages/doxy2.png';
const doxyWeight3 = '/assets/images/services/weight-loss/subpages/doxy3.png';

const tenPercent = '/assets/icons/promotions/10off.png';
const tenPercentPop = '/assets/icons/promotions/10offPop.png';
const hundredPercent = '/assets/icons/promotions/100off.png';
const hundredPercentPop = '/assets/icons/promotions/100offPop.png';
const footerLogo1 = '/assets/images/new/footerLogo1.png';
const footerLogo2 = '/assets/images/new/footerLogo2.png';
const footerLogo3 = '/assets/images/new/footerLogo3.png';
const footerLogo4 = '/assets/images/new/footerLogo4.png';
const footerLogo5 = '/assets/images/new/footerLogo5.png';
const footerLogo6 = '/assets/images/new/footerLogo6.png';
const footerLogo7 = '/assets/images/new/footerLogo7.png';
const mobileLogo = '/assets/images/new/mobileLogo.png';
const logoLarge = '/assets/images/new/logoLarge.png';
const transformMobile = '/assets/images/new/transformMobile.png';
const transformLarge = '/assets/images/new/transformLarge.png';
const transformXL = '/assets/images/new/transformXL.png';
const work1 = '/assets/images/new/work1.png';
const work2 = '/assets/images/new/work2.png';
const work3 = '/assets/images/new/work3.png';
const work4 = '/assets/images/new/work4.png';
const ctaLarge = '/assets/images/new/ctaLarge.jpg';
const ctaOverlaySmall = '/assets/images/new/ctaOverlaySmall.png';
const ctaOverlayLarge = '/assets/images/new/ctaOverlayLarge.png';
const helpImg = '/assets/images/new/helpImg.png';
const general = '/assets/images/new/general.png';
const generalXL = '/assets/images/new/generalNew.png';
const systemXL = '/assets/images/new/systemNew.png';
const medicalXL = '/assets/images/new/medicalNew.png';
const billingXL = '/assets/images/new/billingNew.png';
const sexualHealthMobile = '/assets/images/new/sexualHealthMobile.png';
const sexualHealthLarge = '/assets/images/new/sexualHealthLarge.jpg';
const trustPilotLogo = '/assets/images/new/trustPilotLogo.png';
const trustPilotLogoLg = '/assets/images/new/trustPilotLogoLg.png';
const stdImage = '/assets/images/new/stdImage.png';
const onlineQuiz = '/assets/images/new/onlineQuiz.png';
const one2one = '/assets/images/new/one2one.png';
const onlinePrescription = '/assets/images/new/onlinePrescription.png';
const overlayBlue = '/assets/images/new/overlay.png';
const overlayGreen = '/assets/images/new/overlayOne.png';
const imgBlue = '/assets/images/new/imgBlue.png';
const imgGreen = '/assets/images/new/imgGreen.png';
const weightLossImg = '/assets/images/new/weightLoss3.png';
const weightLoss1 = '/assets/images/new/weightLossZ1.png';
const overlayImage = '/assets/images/new/overlayImage.png';
const badgeOral = '/assets/images/new/badgeOral.png';
const badgeSema = '/assets/images/new/badgeSema.png';
const overlaySema = '/assets/images/new/overlaySema.png';
const overlayOral = '/assets/images/new/overlayOral.png';
const bottomWeightLoss = '/assets/images/new/bottomWeightLoss.jpg';
const betterstats = '/assets/images/new/betterstats.png';
const bottomWeightLoss2 = '/assets/images/new/bottomWeightLoss2.jpg';
const bottomWeightLoss3 = '/assets/images/new/bottomWeightLoss3.jpg';
const bgGreen = '/assets/images/new/bgGreen.jpg';
const bgGreenNew = '/assets/images/new/bgGreenNew.png';
const progress = '/assets/images/new/progress.png';
const BSHealth = '/assets/images/new/bottomSexualHealth.jpg';
const doctorAvatar = '/assets/images/new/doctorAvatar.png';
const Stanford = '/assets/images/new/Stanford.png';
const img95 = '/assets/images/new/95.png';
const img20 = '/assets/images/new/20.png';
const img10 = '/assets/images/new/10.png';
const slide1 = '/assets/images/new/slide1.png';
const heroImage1 = '/assets/images/new/heroImage1.png';
const heroImage2 = '/assets/images/new/heroImage2.jpg';
const bottomImage1 = '/assets/images/new/bottomImage1.png';
const bottomImage2 = '/assets/images/new/bottomImage2.png';
const testDisease = '/assets/images/new/disease.png';
const serviceBg = '/assets/images/new/serviceBg.jpg';
const strepThroat = '/assets/images/new/strepThroat.jpg';
const thePills = '/assets/images/new/thePills.png';
const bottomImage3 = '/assets/images/new/bottomImage3.jpg';
const filmImage = '/assets/images/new/filmImage.png';
const serviceBg3 = '/assets/images/new/serviceBg3.png';
const serviceOverlay = '/assets/images/new/serviceOverlay.png';
const serviceOverlayMobile = '/assets/images/new/serviceOverlayMobile.png';
const theDoctor = '/assets/images/new/doctor.png';
const bottomWave = '/assets/images/new/imgBottom.png';
const middleDivCenter = '/assets/images/new/middleDivCenter.png';
const middleDivCenter1 = '/assets/images/new/middleDivCenter1.png';
const rightCare = '/assets/images/new/rightCare.png';
const weightLoss3 = '/assets/images/new/weightLoss1.png';
const weightLoss4 = '/assets/images/new/weightLoss2.png';
const weightLoss1Before = '/assets/images/new/weightLossPerson1Before.png';
const weightLoss1After = '/assets/images/new/weightLossPerson1After.png';
const weightLoss2Before = '/assets/images/new/weightLossPerson2Before.png';
const weightLoss2After = '/assets/images/new/weightLossPerson2After.png';
const weightLossBottomLatest = '/assets/images/new/weightLossLatest.png';
const weightLossBottomMobile = '/assets/images/new/weightLossBottomMobile.png';
const weightMachine = '/assets/images/new/weightMachine.png';
const weightLossGraph = '/assets/images/new/weightLossGraph.png';
const weightLossHeroOverlay = '/assets/images/new/weightLossHeroOverlay.png';
const weightMachineCanvas = '/assets/images/new/weightMachineCanvas1.png';
const treatmentIcon = '/assets/images/new/Treatment.png';
const dosageIcon = '/assets/images/new/Dosage.png';
const lisenceIcon = '/assets/images/new/Lisence.png';
const shippingIcon = '/assets/images/new/Shipping.png';
const weightLoss1BeforeMobile =
  '/assets/images/new/weightLossPerson1Before.png';
const weightLoss1AftereMobile =
  '/assets/images/new/weightLossPerson1AfterMobile.png';
const heroReview = '/assets/images/new/heroReview.png';
const bottomImageReview = '/assets/images/new/bottomImageReviews.png';
const overlayImageReview = '/assets/images/new/bgOverlay3.png';
const prescriptionHero = '/assets/images/new/prescriptionHero.png';
const refillHeroMobile = '/assets/images/new/refillHeroMobile.png';
const prescriptionEligibility = '/assets/images/new/refillImage.png';
const whoBenefits = '/assets/images/new/whoBenefits2.png';
const calendarHeart = '/assets/images/new/calendarHeart.png';
const dialpadFinger = '/assets/images/new/dialpadFinger.png';
const padLockKey = '/assets/images/new/padlockKey.png';
const insuranceHand = '/assets/images/new/insuranceHand.png';
const trustRefill = '/assets/images/new/trustRefill.png';
const prescriptionRefill = '/assets/images/new/prescriptionRefill.png';
const prescriptionRefillMobile =
  '/assets/images/new/prescriptionRefillMobile.png';
const checkVerified = '/assets/images/new/checkVerified.png';
const prescriptionAbsolute = '/assets/images/new/prescriptionAbsolute.png';
const prescriptionAbsoluteSmall =
  '/assets/images/new/prescriptionAbsoluteSmall.png';
const greenBg1 = '/assets/images/new/greenBg1.png';
const happyDoc = '/assets/images/new/happyDoc.png';
const doc1 = '/assets/images/new/doc1.png';
const doc01 = '/assets/images/new/doc2.png';
const doc02 = '/assets/images/new/doc03.png';
const loginLogo = '/assets/images/new/loginLogo.png';
const gridImage1 = '/assets/images/new/gridImage1.png';
const gridImage2 = '/assets/images/new/gridImage2.png';
const gridImage3 = '/assets/images/new/gridImage3.png';
const gridImage4 = '/assets/images/new/gridImage4.png';
const bottomWave1 = '/assets/images/new/theBottomWaveNew.png';
const greenStar = '/assets/images/new/greenStar.png';
const weightMachineLg = '/assets/images/new/weightMachineLg.png';
const weightMachineXL = '/assets/images/new/weightMachineXL.png';
const doctorInsight1 = '/assets/images/new/doctorInsight1.png';
const blogPills = '/assets/images/new/blogPills.png';
const fbIcon = '/assets/images/new/fb.png';
const instaIcon = '/assets/images/new/insta.png';
const twitterIcon = '/assets/images/new/twitter.png';
const linkedinIcon = '/assets/images/new/linked.png';
const youTubeIcon = '/assets/images/new/utube.png';

const signupformImg = '/assets/images/new/signupformImg2.png';
const signupformImg1 = '/assets/images/new/signupformImg1.png';
const whiteCheck = '/assets/images/new/whiteCheck.png';
const trustPilotRating = '/assets/images/new/trustPilotRating.png';
const loginformImg = '/assets/images/new/loginformImg.png';
const locationImg = '/assets/images/new/locationImg.png';
const notFoundFolder = '/assets/images/new/notFoundFolder.png';
const greenCheck = '/assets/images/new/greenCheck.png';
const lightningDisc = '/assets/images/new/lightningDisc.png';
const trustPilotNew = '/assets/images/new/trustPilotNew.png';
const newImage = '/assets/images/new/newImage.png';
const bannerNew = '/assets/images/new/bannerNew.png';
const boltWhite = '/assets/images/new/boltWhite.png';
const boltBlack = '/assets/images/new/boltBlack.png';
const trustPilotNewer = '/assets/images/new/trustPilotNewer.png';
const theStars = '/assets/images/new/theStars.png';
const LogoNew = '/assets/images/new/LogoNew.png';
const reviewimage = '/assets/images/new/reviewimage.png';
//**weight loss */
const WL_Product = '/assets/images/new/WL_Product1.png';
const weightLossBtmNew = '/assets/images/new/weightLossBtmNew.png';
const starimages = '/assets/images/new/starimages.png';
const weightloss = '/assets/images/new/weightloss.png';
const sexualcare = '/assets/images/new/sexualcare.png';
const urgentcare = '/assets/images/new/urgentcare.png';
const dentalcare = '/assets/images/new/dentalcare.png';
const refills = '/assets/images/new/refills.png';
const trustPilotReviewNew = '/assets/images/new/trustPilotReviewNew.png';
const excellentNew = '/assets/images/new/excellentNew.png';
const sub1 = '/assets/images/new/sub1.png';
const sub2 = '/assets/images/new/sub2.png';
const sub3 = '/assets/images/new/sub3.png';
const subBg = '/assets/images/new/subBg.png';
const fullaccess = '/assets/images/new/fullaccess.png';
const fullyear = '/assets/images/new/fullyear.png';
const nohiddenfees = '/assets/images/new/no-hidden-fees.png';
const simplehealth = '/assets/images/new/simplehealth.png';
const saveFifty = '/assets/images/new/save50.png';
const subBgBottom = '/assets/images/new/subBgBottom.png';
const subBenefits = '/assets/images/new/subBenefits.png';
const subHeroBg = '/assets/images/new/subHeroBg.png';
const theSubscription = '/assets/images/new/theSubscription.png';
const testFrame = '/assets/images/new/testFrame1.png';
const newSectionImg = '/assets/images/new/newSectionImg.png';
const newSectionImg2 = '/assets/images/new/newSectionImg2.png';
const newSectionImg3 = '/assets/images/new/newSectionImg3.png';
const newSectionImg4 = '/assets/images/new/newSectionImg4.png';
const newSectionImg5 = '/assets/images/new/newSectionImg5.png';
const newSectionImg6 = '/assets/images/new/newSectionImg6.png';
const placeholder = '/assets/images/new/placeholder.png';
const subscribeHero = '/assets/images/new/subscribeHero.png';
const subscriptionHero = '/assets/images/subscription/hero.png';
const subscriptionMid = '/assets/images/subscription/mid.png';
const subscriptionBottom = '/assets/images/subscription/end.png';

const creditCards = '/assets/images/new/creditCards.png';
const creditCardMobile = '/assets/images/new/creditCardMobile.png';

const subscribeSignUp = '/assets/images/new/subscribeSignUp.png';
const microdosingbtm = '/assets/images/new/microdosingbtm.png';
const microdosingCTA = '/assets/images/new/microdosingCTA.png';
const advantageImg = '/assets/images/new/advantageImg.png';
const microImg = '/assets/images/new/microImg.png';

const carecoaching = '/assets/images/new/carecoaching.png';
const microdosingHero = '/assets/images/new/microdosingHero.png';
const microNew = '/assets/images/new/microdosing/microdosingHero.png';
const metformin = '/assets/images/new/metformin.png';
const b12injection = '/assets/images/new/b12injection.png';
const microglp = '/assets/images/new/microglp.png';
const micro1 = '/assets/images/new/microdosing/mockup1.png';
const micro2 = '/assets/images/new/microdosing/mockup2.png';
const micro3 = '/assets/images/new/microdosing/mockup3.png';
const microBG = '/assets/images/new/microdosing/bg-micro.png';
const miniModalImg = '/assets/images/new/microdosing/mini-modal-img.png';

//New homepage
const homeHero = '/assets/images/v2/home2.png';
const herohome1 = '/assets/images/v2/herohome1.jpg';
const herohome2 = '/assets/images/v2/herohome2.jpg';
const herohome3 = '/assets/images/v2/herohome3.jpg';
const herohome4 = '/assets/images/v2/herohome4.jpg';
const hIW2 = '/assets/images/v2/how2.png';
const hIW3 = '/assets/images/v2/how3.png';
const ED1 = '/assets/images/v2/ED1.png';

//New Subscription page
const subscriptionHero2 = '/assets/images/v2/subscription-1.png';
// Ed page
const EDHero = '/assets/images/v2/EDHero.png';

const refillHero = '/assets/images/new/refillHero1.png';
const refillStep1 = '/assets/images/new/refillStep1.png';
const refillStep2 = '/assets/images/new/refillStep2.png';
const refillStep3 = '/assets/images/new/refillStep3.png';
const dashedLines = '/assets/images/new/dashedLines.png';
const labHero = '/assets/images/new/labHero.png';
const labStep1 = '/assets/images/new/labStep1.png';
const labStep2 = '/assets/images/new/labStep2.png';
const labStep3 = '/assets/images/new/labStep3.png';
const weightLossStep1 = '/assets/images/new/weightLossStep1.png';
const weightLossStep2 = '/assets/images/new/weightLossStep2.png';
const weightLossStep3 = '/assets/images/new/weightLossStep3.png';
const weightLossBenefits = '/assets/images/new/weightLossBenefits1.png';
const sideEffects = '/assets/images/new/sideEffects1.png';
const weightLossPrograms = '/assets/images/new/weightLossPrograms.png';
const weightLossPrograms1 = '/assets/images/new/weightLossPrograms1.png';
const stdHero = '/assets/images/new/stdHero.jpg';
const stdStep1 = '/assets/images/new/stdStep1.png';
const stdStep2 = '/assets/images/new/stdStep2.png';
const stdStep3 = '/assets/images/new/stdStep3.png';
const dashedLinesBlue = '/assets/images/new/dashedLinesBlue.png';
const tickmark = '/assets/images/new/tickmark.png';
const aboutUs = '/assets/images/v2/aboutUs.png';
const aboutUsStep3 = '/assets/images/new/aboutUsStep3.png';
const weightLossStep3a = '/assets/images/new/weightLossStep3a.png';

const pillsImg = '/assets/images/new/pills1.png';
const medicineBottle = '/assets/images/v2/medicineBottle.png';
const heroMedication = '/assets/images/v2/heroMedication1.png';
const medicationStep3 = '/assets/images/v2/medicationStep3.png';
const medicationSection3 = '/assets/images/v2/medicationSection3a.png';
const medicationRefill = '/assets/images/v2/medicationRefill.png';
const starsRow = '/assets/images/v2/starsRow.png';
const heroAllConditions = '/assets/images/v2/heroAllConditions.png';
const serviceSection3 = '/assets/images/v2/serviceSection3.png';

//MedicationPage v2
const medication3 = '/assets/images/v2/medication3.png';
const medicationFooter = '/assets/images/v2/medicationfooter.png';
const ratingContainer = '/assets/images/v2/rating-container.png';

const flowWelcome = '/assets/images/v2/flowWelcome.png';
const aboutUsStep1 = '/assets/images/new/aboutUsStep1.png';
const aboutUsStep2 = '/assets/images/new/aboutUsStep2.png';
const homeStep3 = '/assets/images/new/homeStep3.png';

//Lab-testing v2
const labHow1 = '/assets/images/v2/labhow1.png';
const labHow2 = '/assets/images/v2/labhow2.png';
const labHow3 = '/assets/images/v2/labhow3.png';
const howStep3 = '/assets/images/new/howStep3.png';
const labTestStep3 = '/assets/images/new/labTestStep3.png';
const subStep3 = '/assets/images/new/subStep3.png';
const productMicrodosing = '/assets/images/new/productMicrodosing.png';
const muscleEnergy = '/assets/images/new/muscleEnergy.png';
const sleepSupport = '/assets/images/new/sleepSupport.png';
const energyMental = '/assets/images/new/energyMental.png';
const bgGradient = '/assets/images/new/bg-gradient1.png';
const bgGradient1 = '/assets/images/new/bg-gradienttest1.png';
const medicalinfo = '/assets/images/new/medicalinfo.png';
const curve1 = '/assets/images/new/curve1.png';
const curve2 = '/assets/images/new/curve2.png';
const pill = '/assets/images/new/pill.png';
const pharmacy1 = '/assets/images/new/pharmacy.png';
const WL_ProductMobile = '/assets/images/v2/WL_ProductMobile1.png';
const WL_BenefitsMobile = '/assets/images/v2/WL_BenefitsMobile.png';
const WL_SideeffectsMobile = '/assets/images/v2/WL_SideeffectsMobile.png';
const OS_Mobile = '/assets/images/v2/OS_Mobile.png';
const FooterBanner1 = '/assets/images/new/FooterBanner1.png';

// Brand Facts page (Figma: 24hrDoc Web Design Final, node 30058:2446)
const bfHeroDoctor = '/assets/images/brand-facts/hero-doctor.jpg';
const bfHeroPatient = '/assets/images/brand-facts/hero-patient.jpg';
const bfWhatMain = '/assets/images/brand-facts/what-main.jpg';
const bfWhatInset = '/assets/images/brand-facts/what-inset.jpg';
const bfProvidersMain = '/assets/images/brand-facts/providers-main.jpg';
const bfProvidersInset = '/assets/images/brand-facts/providers-inset.jpg';
const bfAccessMain = '/assets/images/brand-facts/access-main.jpg';
const bfAccessInset = '/assets/images/brand-facts/access-inset.jpg';
const bfSafetyMain = '/assets/images/brand-facts/safety-main.jpg';
const bfSafetyInset = '/assets/images/brand-facts/safety-inset.jpg';
const bfHowItWorks = '/assets/images/brand-facts/how-it-works.jpg';
const bfCatUrgentCare = '/assets/images/brand-facts/cat-urgent-care.jpg';
const bfCatMensHealth = '/assets/images/brand-facts/cat-mens-health.jpg';
const bfCatWomensHealth = '/assets/images/brand-facts/cat-womens-health.jpg';
const bfCatSexualHealth = '/assets/images/brand-facts/cat-sexual-health.jpg';
const bfCatDermatology = '/assets/images/brand-facts/cat-dermatology.jpg';

export {
  FooterBanner1,
  weightLossPrograms1,
  bgGreenNew,
  weightLossStep3a,
  OS_Mobile,
  WL_BenefitsMobile,
  WL_ProductMobile,
  WL_SideeffectsMobile,
  curve1,
  curve2,
  pharmacy1,
  pill,
  medicalinfo,
  bgGradient1,
  bgGradient,
  weightLossBtmNew,
  WL_Product,
  herohome1,
  herohome2,
  herohome3,
  herohome4,
  labHow1,
  labHow2,
  labHow3,
  subStep3,
  labTestStep3,
  howStep3,
  homeStep3,
  aboutUsStep2,
  aboutUsStep1,
  energyMental,
  sleepSupport,
  muscleEnergy,
  productMicrodosing,
  refills,
  flowWelcome,
  ratingContainer,
  medication3,
  medicationFooter,
  heroMedication,
  medicationStep3,
  medicationSection3,
  medicationRefill,
  starsRow,
  heroAllConditions,
  serviceSection3,
  EDHero,
  subscriptionHero2,
  ED1,
  homeHero,
  hIW2,
  hIW3,
  medicineBottle,
  pillsImg,
  aboutUsStep3,
  aboutUs,
  tickmark,
  dashedLinesBlue,
  stdStep1,
  stdStep2,
  stdStep3,
  stdHero,
  weightLossPrograms,
  sideEffects,
  weightLossBenefits,
  weightLossStep1,
  weightLossStep2,
  weightLossStep3,
  labStep3,
  labStep2,
  labStep1,
  labHero,
  dashedLines,
  refillStep3,
  refillStep2,
  refillStep1,
  refillHero,
  miniModalImg,
  newSectionImg5,
  creditCardMobile,
  creditCards,
  microBG,
  micro1,
  micro2,
  micro3,
  b12injection,
  microglp,
  metformin,
  microNew,
  microdosingHero,
  carecoaching,
  subscriptionHero,
  subscriptionMid,
  subscriptionBottom,
  microImg,
  advantageImg,
  microdosingCTA,
  microdosingbtm,
  subscribeHero,
  subscribeSignUp,
  placeholder,
  newSectionImg6,
  newSectionImg4,
  newSectionImg3,
  newSectionImg2,
  newSectionImg,
  sub1,
  sub2,
  sub3,
  subBg,
  fullaccess,
  fullyear,
  nohiddenfees,
  simplehealth,
  saveFifty,
  subBgBottom,
  subHeroBg,
  theSubscription,
  testFrame,
  excellentNew,
  subBenefits,
  trustPilotReviewNew,
  weightloss,
  sexualcare,
  urgentcare,
  dentalcare,
  starimages,
  reviewimage,
  about1,
  about2,
  about3,
  about4,
  about5,
  acid1,
  acid2,
  acne,
  acneCauses,
  adhd1,
  adhd2,
  allergy1,
  allergy2,
  anxiety,
  anxietyCauses,
  arrowServices,
  Athlete,
  avatar,
  avatarFemale,
  bacteria1,
  badgeOral,
  badgeSema,
  bannerCard,
  bannerWeight1,
  bannerWeight2,
  bannerWeight3,
  bcIcon1,
  bcIcon2,
  bcIcon3,
  bcIcon4,
  betterstats,
  bgGreen,
  billingXL,
  birthControl,
  blogBanner,
  blogPills,
  bloodDraw,
  board1,
  boil1,
  bottomImage1,
  bottomImage2,
  bottomImage3,
  bottomImageReview,
  bottomWave,
  bottomWave1,
  bottomWeightLoss,
  bottomWeightLoss2,
  bottomWeightLoss3,
  briefCase,
  bronchitis,
  bronchitis2,
  BSHealth,
  bulletpoint,
  bulletpointInvert,
  calendarHeart,
  card1,
  card2,
  card3,
  card4,
  careerBanner,
  checkVerified,
  chlamydia1,
  chlamydia2,
  chlamydia3,
  chlamydiaTreatment,
  circle,
  circles,
  circlesR,
  clip,
  common,
  cross,
  ctaLarge,
  ctaOverlayLarge,
  ctaOverlaySmall,
  dental1,
  dental2,
  dental3,
  dentalTreatment,
  depression,
  diabetes1,
  diabetes2,
  diabetes3,
  dialpadFinger,
  diseaseTreatment2,
  doc,
  doc01,
  doc02,
  doc1,
  doc2,
  doc3,
  doctor,
  doctorAvatar,
  doctorInsight1,
  docTreatment,
  dosageIcon,
  doxy1,
  doxy2,
  doxyWeight1,
  doxyWeight2,
  doxyWeight3,
  dp1,
  dp2,
  dp3,
  dp4,
  dp5,
  dp6,
  eyelashGrowth,
  eyelashGrowth2,
  faqImage,
  faqs,
  fbIcon,
  filmImage,
  firstWeight,
  footerLogo1,
  footerLogo2,
  footerLogo3,
  footerLogo4,
  footerLogo5,
  footerLogo6,
  footerLogo7,
  general,
  generalXL,
  genitalWarts,
  goals,
  gonorrhea1,
  gonorrhea2,
  gonorrhea3,
  gonorrheaTreatment,
  greenBg1,
  greenCircle,
  greenStar,
  gridImage1,
  gridImage2,
  gridImage3,
  gridImage4,
  hair,
  hairloss,
  hairloss2,
  happyDoc,
  headerBG,
  helpImg,
  heroImage1,
  heroImage2,
  heroReview,
  heroWeight,
  heroWeightWeight,
  homeModalImage1,
  homeModalImage2,
  homeModalImage3,
  homepage1,
  homepage2,
  homeProp1,
  homeProp2,
  how1,
  how1Refill,
  how2,
  how2Refill,
  how3,
  how3Refill,
  howItworks1,
  howItworks2,
  howItworks3,
  howToWeight1,
  howToWeight2,
  howToWeight3,
  hundredPercent,
  hundredPercentPop,
  iconRefill1,
  iconRefill2,
  img10,
  img20,
  img95,
  imgBlue,
  imgGreen,
  insomnia,
  insomniaCauses,
  instaIcon,
  insuranceHand,
  jockItch,
  lab,
  labReview,
  labSelect,
  lice,
  liceTransmission,
  linkedinIcon,
  lisenceIcon,
  location,
  locationImg,
  login,
  loginformImg,
  loginLogo,
  logoLarge,
  logoSite,
  LogoTransparent,
  logoWhite,
  logoWhiteFull,
  medicalXL,
  mens,
  menSign,
  mental,
  mental3,
  mental4,
  mental5,
  mentalHealthGraphic,
  mentalHero,
  mentalHeroElement,
  mentalType1,
  middleDivCenter,
  middleDivCenter1,
  migraine,
  migraineCauses,
  mission,
  mobileLogo,
  motionSickness,
  Mycoplasma,
  Mycoplasma2,
  notehow1,
  notehow2,
  notehow3,
  notepipeBlue,
  notepipeBlueTwo,
  notepipeGreen,
  notFoundFolder,
  one2one,
  onlinePrescription,
  onlineQuiz,
  oralThrush,
  overlayBlue,
  overlayGreen,
  overlayImage,
  overlayImageReview,
  overlayOral,
  overlaySema,
  padLockKey,
  periodDelay,
  pharmacy,
  phone,
  phoneView,
  pinkeye2,
  pinkEyes,
  plusWomen,
  poisonIvy,
  polygon1,
  polygon2,
  prescriptionAbsolute,
  prescriptionAbsoluteSmall,
  prescriptionEligibility,
  prescriptionHero,
  prescriptionRefill,
  prescriptionRefillMobile,
  progress,
  psoriasis,
  psoriasisCauses,
  redWeight,
  refill2,
  refill3,
  refill4,
  refillBottle,
  refillHeroMobile,
  rightArrow,
  rightCare,
  scabies,
  secondWeight,
  semaglutide,
  semaglutide2,
  semaglutide3,
  semaglutide4,
  semaglutideIcon1,
  semaglutideIcon2,
  semaglutideIcon3,
  semaglutideMobile,
  serviceBg,
  serviceBg3,
  serviceOverlay,
  serviceOverlayMobile,
  sexualHealthLarge,
  sexualHealthMobile,
  shippingIcon,
  sickNote1,
  signupformImg,
  signupformImg1,
  slide1,
  smoking1,
  smoking2,
  socialAnxiety,
  socialAnxietyCauses,
  Stanford,
  stars,
  std,
  std1,
  std2,
  std3,
  stdCircleBlue,
  stdCircleGreen,
  stdDoctor1,
  stdDoctor3,
  stdDoctor4,
  stddr1,
  stdImage,
  strepThroat,
  Stye,
  swirls,
  systemXL,
  tabs,
  tenPercent,
  tenPercentPop,
  testDisease,
  thankyou,
  theDoctor,
  thePills,
  thirdWeight,
  tick,
  tickBlack,
  tickGreen,
  tickWhite,
  transformLarge,
  transformMobile,
  transformXL,
  treatmentIcon,
  treatmentPlan2,
  treatmentPlanSTD,
  treatments,
  trustPilotLogo,
  trustPilotLogoLg,
  trustPilotRating,
  trustRefill,
  twitterIcon,
  UMC1,
  UMCdr1,
  UMCdr2,
  UMCheader1,
  UMCheader2,
  UMCheader3,
  UMCheader4,
  UMCheader5,
  UMChexa,
  UMChexaEmpty,
  UMChiw1,
  UMChiw2,
  UMChiw3,
  UMCjalebi,
  UMCpricing,
  UMCstat1,
  UMCstat2,
  UMCstat3,
  Ureaplasma,
  Ureaplasma2,
  Urethritis,
  Urethritis2,
  uti1,
  uti3,
  vaginosis1,
  vaginosis2,
  vaginosis3,
  vendor,
  vision,
  watch,
  waves,
  weightLoss,
  weightloss1,
  weightLoss1,
  weightLoss1After,
  weightLoss1AftereMobile,
  weightLoss1Before,
  weightLoss1BeforeMobile,
  weightloss2,
  weightLoss2After,
  weightLoss2Before,
  weightLoss3,
  weightLoss4,
  weightLossBottomLatest,
  weightLossBottomMobile,
  weightLossGraph,
  weightLossHeroOverlay,
  weightLossImg,
  weightLossTreatment,
  weightMachine,
  weightMachineCanvas,
  weightMachineLg,
  weightMachineXL,
  weightProgram1,
  weightProgram2,
  weightProgram3,
  whiteCheck,
  whoBenefits,
  womanSign,
  womanSignInvert,
  womens,
  work1,
  work2,
  work3,
  work4,
  yellowWeight,
  youTubeIcon,
  greenCheck,
  lightningDisc,
  trustPilotNew,
  newImage,
  bannerNew,
  boltWhite,
  boltBlack,
  trustPilotNewer,
  theStars,
  LogoNew,
  bfHeroDoctor,
  bfHeroPatient,
  bfWhatMain,
  bfWhatInset,
  bfProvidersMain,
  bfProvidersInset,
  bfAccessMain,
  bfAccessInset,
  bfSafetyMain,
  bfSafetyInset,
  bfHowItWorks,
  bfCatUrgentCare,
  bfCatMensHealth,
  bfCatWomensHealth,
  bfCatSexualHealth,
  bfCatDermatology,
};
